import { useContext } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  Typography,
  FormControl,
  MenuItem,
  Select,
  Badge,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import HomeIcon from "@mui/icons-material/Home";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LanguageIcon from "@mui/icons-material/Language";
import TranslateIcon from "@mui/icons-material/Translate";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ScienceIcon from "@mui/icons-material/Science";
import DownloadIcon from "@mui/icons-material/Download";
import doctor from "../assets/images/doctor.png";
import { DetailsToMenu } from "../components/Menu/DetailsToMenu.jsx";
import { NotificationContext } from "../components/Notifications/NotificationContext.jsx";

const CustomDrawer = () => {
  const { language, handleSelectLanguage, clinicianName, handleLogout } =
    useContext(DetailsToMenu);
  const { unreadCount } = useContext(NotificationContext);
  const { t, i18n } = useTranslation("menu");
  const navigate = useNavigate();

  const handleClickLogout = () => {
    handleLogout();
    localStorage.removeItem("authToken");
    localStorage.removeItem("selectedCitizen");
    localStorage.removeItem("clinician_name");
    localStorage.removeItem("lastRoute");
    localStorage.removeItem("userSelectedId");
    localStorage.removeItem("clinician_id");
    localStorage.removeItem("role");
    localStorage.removeItem("selectedStatisticsOption");
    navigate("/");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          marginTop: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src={doctor} width="85px" alt="Doctor" />
        <Typography
          variant="h5"
          fontWeight="500"
          marginTop={2}
          marginBottom={1}
          textAlign="center"
          sx={{ px: 1 }}
        >
          {clinicianName}
        </Typography>
      </Box>
      <Divider sx={{ marginTop: 2 }} />
      <List>
        <ListItem key="home" disablePadding>
          <ListItemButton component={RouterLink} to="/home">
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary={t("home")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="notifications" disablePadding>
          <ListItemButton component={RouterLink} to="/notifications">
            <ListItemIcon>
              <Badge badgeContent={unreadCount} color="error">
                <NotificationsIcon />
              </Badge>
            </ListItemIcon>
            <ListItemText primary={t("notifications")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="citizens" disablePadding>
          <ListItemButton component={RouterLink} to="/citizens">
            <ListItemIcon>
              <AccountBoxIcon />
            </ListItemIcon>
            <ListItemText primary={t("citizens")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="language" disablePadding>
          <ListItemButton
            component="a"
            href="https://www.oncodir.eu/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ListItemIcon>
              <LanguageIcon />
            </ListItemIcon>
            <ListItemText primary={t("oncodirProject")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="profile" disablePadding>
          <ListItemButton component={RouterLink} to="/profile">
            <ListItemIcon>
              <AccountCircleIcon />
            </ListItemIcon>
            <ListItemText primary={t("profile")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="documentation" disablePadding>
          <ListItemButton component={RouterLink} to="/documentation">
            <ListItemIcon>
              <MenuBookIcon />
            </ListItemIcon>
            <ListItemText primary={t("documentation")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="research-documents" disablePadding>
          <ListItemButton component={RouterLink} to="/research-documents">
            <ListItemIcon>
              <ScienceIcon />
            </ListItemIcon>
            <ListItemText primary={t("researchDocuments")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="export" disablePadding>
          <ListItemButton component={RouterLink} to="/export">
            <ListItemIcon>
              <DownloadIcon />
            </ListItemIcon>
            <ListItemText primary={t("export")} />
          </ListItemButton>
        </ListItem>
      </List>

      <Divider />
      <List>
        <ListItem key="languageList">
          <ListItemIcon>
            <TranslateIcon />
          </ListItemIcon>
          <ListItemText primary={t("language")} />
        </ListItem>
      </List>
      <FormControl
        sx={{ marginLeft: 1, width: 160, alignSelf: "center" }}
        size="small"
      >
        <Select
          labelId="select-language"
          id="select-language-small"
          value={language || (i18n.resolvedLanguage || "en").split("-")[0]}
          onChange={(e) => handleSelectLanguage(e.target.value)}
        >
          <MenuItem value={"en"}>English</MenuItem>
          <MenuItem value={"ro"}>Română</MenuItem>
          <MenuItem value={"lt"}>Lietuvių</MenuItem>
        </Select>
      </FormControl>

      <Box sx={{ flexGrow: 1 }} />
      <Divider />
      <List>
        <ListItem key="logout" disablePadding>
          <ListItemButton onClick={handleClickLogout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary={t("logout")} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );
};

export default CustomDrawer;
